import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ImageSelectPopup.css';
import { getStoredData } from "../../json/fetchData";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

const ImageSelectPopup = ({ isOpen, onClose, onSelect }) => {
  const [files, setFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filesFetched, setFilesFetched] = useState(false);
  const [data, setData] = useState(null);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [isZoomOpen, setIsZoomOpen] = useState(false);

  useEffect(() => {
    const totalData = getStoredData();
    const data = totalData ? totalData["11"].AdminFileManagement : {};
    setData(data);
  }, []);

  useEffect(() => {
    if (data && !filesFetched) {
      const fetchFiles = async () => {
        try {
          const response = await axios.get(data.ApiView);
          setFiles(response.data.files);
          setFilesFetched(true);
        } catch (error) {
          console.error('Error fetching files:', error);
        }
      };

      fetchFiles();
    }
  }, [data, filesFetched]);

  const filteredFiles = files.filter((file) =>
    file.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectImage = (image) => {
    onSelect(image.url);
    onClose();
  };

  const handleRightClick = (e, image) => {
    e.preventDefault();
    setZoomedImage(`/images/${image.name}`);
    setIsZoomOpen(true);
  };

  const closeZoomModal = () => {
    setIsZoomOpen(false);
    setZoomedImage(null);
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <h3>Select an Image</h3>

        <input
          type="text"
          placeholder="Search images..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="Imagesearch-input"
        />

        {filesFetched && (
          <div className="image-list">
            {filteredFiles.map((image, index) => (
              <div
                className="image-item"
                key={index}
                onClick={() => handleSelectImage(image)}
                onContextMenu={(e) => handleRightClick(e, image)}
              >
                <img
                  src={`/images/${image.name}`}
                  alt={image.name}
                  className="popup-image"
                  loading="lazy"
                />
                <span>{image.name}</span>
              </div>
            ))}
          </div>
        )}

        <button className="close-popup" onClick={onClose}>
          <FontAwesomeIcon icon={faClose} />
        </button>
      </div>

      {isZoomOpen && (
        <div className="zoom-overlay" onClick={closeZoomModal}>
          <div className="zoom-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={zoomedImage}
              alt="Zoomed"
              className="zoomed-image"
            />
            <button className="close-zoom" onClick={closeZoomModal}>
              <FontAwesomeIcon icon={faClose} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSelectPopup;
